module.exports = __webpack_public_path__ + "img/logo6.3f56eb33.jpg";